<script setup lang="ts">
  import { useFetchDataFromStoryblok } from '@/composables/fetchDataFromStoryblok'
  import { useGlobalSettingsStore } from '@/stores/GlobalSettings.store'
  import type { MainNavigationStoryblok } from '@/storyblok/component-types-sb'
  import { useMainHeaderStore } from '@/components/main-header/store'

  const globalSettingsStore = useGlobalSettingsStore()

  const { globalAlert } = storeToRefs(globalSettingsStore)

  withDefaults(defineProps<{ isIndex?: boolean }>(), { isIndex: false })

  const { isDesktop } = useBTBreakpoints()

  const slug = 'main-navigation/main-navigation'
  const resolveRelations = [
    'main-navigation.tabs',
    'navigation-section.title',
    'navigation-section.blocks',
    'navigation-items.children',
    'navigation-items.link',
    'app.playStoreHref',
    'app.appleStoreHref'
  ]

  const mainNavigationStory = await useFetchDataFromStoryblok(slug, resolveRelations)
  const mainNavigationContent = mainNavigationStory.value?.content as MainNavigationStoryblok

  const tabs = computed(() => parseTabs(mainNavigationContent))
  const sections = computed(() => parseStoryContent(mainNavigationContent))

  const isScrollLocked = useScrollLock(document)

  const mainHeaderStore = useMainHeaderStore()
  watch(
    () => mainHeaderStore.activeSection,
    (value) => (mainHeaderStore.isMenuOpen = !!value)
  )

  watch(
    () => mainHeaderStore.isMenuOpen,
    (value) => (isScrollLocked.value = !!value)
  )
</script>
<template>
  <LazyMainHeaderGlobalAlert
    v-if="globalAlert"
    v-bind="globalAlert"
  />
  <header class="sticky top-0 z-10 border-b border-divider bg-white">
    <UiSkipToContent />
    <div class="relative">
      <MainHeaderTopBar />
      <MainHeaderNavigation
        :header-data="{ tabs, sections }"
        :class="{ hidden: !isIndex }"
      />
      <LazyMainHeaderSectionsDropdown
        v-if="isDesktop"
        v-show="mainHeaderStore.isMenuOpen"
        :active-section="mainHeaderStore.activeSection"
        @close="mainHeaderStore.activeSection = null"
      />
      <LazyMainHeaderMobileSidebar
        v-else
        v-show="mainHeaderStore.isMenuOpen"
        :sidebar-data="{ tabs, sections }"
        @close="mainHeaderStore.isMenuOpen = false"
      />
    </div>
  </header>
</template>
